import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { NotificationPreference, NotificationPreferenceCreate, NotificationPreferenceFilter } from '../data/notificationPreference';

export function createNotificationPreferenceService(client: AxiosInstance) {
  return createCrudService<NotificationPreference, NotificationPreferenceCreate, NotificationPreferenceFilter>(
    client,
    '/notifications/NotificationPreference',
    'id',
  );
}

export type NotificationPreferenceService = CrudService<NotificationPreference, NotificationPreferenceCreate, NotificationPreferenceFilter>;
